import React, { FC, ReactNode } from "react"
import { Link, useRouteMatch } from "react-router-dom"
import styles from "./MenuItem.module.css"

interface MenuItemProps {
    children: ReactNode
    icon?: FC<{ size: "lg"; className?: string }>
    iconClassName?: string
    size?: "md" | "sm"
    to: string
    match?: "exact" | "prefix" | "never"
}

export function MenuItem({
    to,
    icon: Icon,
    iconClassName = "",
    children,
    size = "md",
    match = "prefix"
}: MenuItemProps) {
    const routeMatch = useRouteMatch(to)
    const isActive =
        match === "never"
            ? false
            : routeMatch !== null && (match !== "exact" || routeMatch.isExact)
    const commonClassName = [
        "no-underline flex items-center",
        isActive ? styles.MenuItem_active : "",
        styles.MenuItem,
        Icon === undefined ? "pl-14 pr-6" : "px-6",
        size === "sm" ? "text-sm py-1" : "py-2"
    ].join(" ")
    const body = (
        <>
            {Icon !== undefined && (
                <Icon
                    className={`w-5 h-5 mr-3 flex-shrink-0 ${iconClassName}`}
                    size="lg"
                />
            )}
            {children}
        </>
    )

    if (match === "never" && routeMatch !== null) {
        // unclickable parent menu
        return <div className={commonClassName}>{body}</div>
    }

    return (
        <Link
            to={to}
            className={`${commonClassName} ${styles.MenuItem_clickable}`}
        >
            {body}
        </Link>
    )
}
